var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconUnpublish(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    width: 56,
    height: 56,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#009051"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    width: 24,
    height: 24,
    d: "M 33.394 35.08 L 21.727 35.08 L 21.727 33.414 L 33.394 33.414 L 33.394 35.08 Z M 33.394 26.747 L 30.061 26.747 L 30.061 21.747 L 25.061 21.747 L 25.061 26.747 L 21.727 26.747 L 27.561 32.58 L 33.394 26.747 Z M 26.727 28.414 L 26.727 23.414 L 28.394 23.414 L 28.394 28.414 L 29.369 28.414 L 27.561 30.222 L 25.752 28.414 L 26.727 28.414 Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUnpublish);
export default __webpack_public_path__ + "static/media/icon-unpublish.945173bb422ec6b0d03aa69abad380b9.svg";
export { ForwardRef as ReactComponent };